const Kitchen = props => {
    return (
        <svg className={props.className || ""} viewBox="0 -960 960 960" ><path d="M323.85-640v-112.31h59.99V-640h-59.99Zm0 342.31v-186.93h59.99v186.93h-59.99ZM252.31-100q-29.92 0-51.12-21.19Q180-142.39 180-172.31v-615.38q0-29.92 21.19-51.12Q222.39-860 252.31-860h455.38q29.92 0 51.12 21.19Q780-817.61 780-787.69v615.38q0 29.92-21.19 51.12Q737.61-100 707.69-100H252.31Zm0-60h455.38q5.39 0 8.85-3.46t3.46-8.85v-360H240v360q0 5.39 3.46 8.85t8.85 3.46ZM240-592.31h480v-195.38q0-5.39-3.46-8.85t-8.85-3.46H252.31q-5.39 0-8.85 3.46t-3.46 8.85v195.38Z"/></svg>
    )
}

export default Kitchen;